class BlogLoadMore extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.grid = this.querySelector('#InMediaGrid');
    this.btn = this.querySelector('#InMediaLoadMore');

    this.btn?.addEventListener('click', e => {
      e.preventDefault();
      this._loadMore();
    });
  }

  _setLoading(loading) {
    if (loading) {
      const spinner = document.createElement('span');
      spinner.classList.add('spinner');
      this.btn.appendChild(spinner);
      this.btn.classList.add('btn--loading');
      this.btn.dataset.loading = '';
      this.btn.disabled = true;
    } else {
      this.btn.querySelector('.spinner')?.remove();
      this.btn.classList.remove('btn--loading');
      delete this.btn.dataset.loading;
      this.btn.disabled = false;
    }
  }

  async _loadMore() {
    const url = this.btn.href;
    if (!url) return;

    this._setLoading(true);

    try {
      const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${this.sectionId}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      doc.querySelectorAll('#InMediaGrid > *').forEach(item => this.grid.appendChild(item));

      const newBtn = doc.querySelector('#InMediaLoadMore');
      if (newBtn) {
        this.btn.href = newBtn.href;
        this._setLoading(false);
      } else {
        this.btn.closest('.in-media-blog-list__load-more')?.remove();
      }
    } catch (err) {
      console.error('BlogLoadMore: fetch error', err);
      this._setLoading(false);
    }
  }
}

if (!customElements.get('blog-load-more')) {
  customElements.define('blog-load-more', BlogLoadMore);
}
